export default {"src":"/_next/static/media/optimize-supply-chain.bd161ea0.svg","height":32,"width":33};